var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDesignerPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "gridBorder",
    x: 9,
    y: 20,
    width: 122,
    height: 122,
    rx: 10,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bottomCellBorder",
    x: 16,
    y: 27,
    width: 108,
    height: 108,
    rx: 5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted8",
    d: "M13 31.5C13 27.1 15.6667 25.3333 17 25C51 24.6667 119.6 24.1 122 24.5C124.4 24.9 126 28.6667 126.5 30.5L127 56L122 51C119.667 48 112.2 40.7 101 35.5C87 29 83.5 29.5 66.5 26C52.9 23.2 30.5 37.8333 21 45.5C19.1667 47.5 15 52.1 13 54.5C10.5 57.5 13 37 13 31.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted7",
    d: "M20.0988 58.5C13.0988 64.5 14.0988 55 14.0988 49.5C14.0988 44 36.5 21 69 21C101.5 21 125.099 44 125.099 48.5C125.099 53 129.599 66 121.599 58C113.599 50 27.0988 52.5 20.0988 58.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted6",
    d: "M20.0494 71.5C13.0494 77.5 14.0494 68 14.0494 62.5C14.0494 57 36.0494 33 68.5494 33C101.049 33 125.049 57 125.049 61.5C125.049 66 129.549 79 121.549 71C113.549 63 27.0494 65.5 20.0494 71.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted5",
    d: "M20.0988 84.5C13.0988 90.5 14.0988 81 14.0988 75.5C14.0988 70 36.0988 46 68.5988 46C101.099 46 125.099 70 125.099 74.5C125.099 79 129.599 92 121.599 84C113.599 76 27.0988 78.5 20.0988 84.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted4",
    d: "M20.0494 97.5C13.0494 103.5 14.0494 94 14.0494 88.5C14.0494 83 36.0494 59 68.5494 59C101.049 59 125.049 83 125.049 87.5C125.049 92 129.549 105 121.549 97C113.549 89 27.0494 91.5 20.0494 97.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted3",
    d: "M20.0494 110.5C13.0494 116.5 14.0494 107 14.0494 101.5C14.0494 96 36.0494 72 68.5494 72C101.049 72 125.049 96 125.049 100.5C125.049 105 129.549 118 121.549 110C113.549 102 27.0494 104.5 20.0494 110.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted2",
    d: "M20 123.5C13 129.5 14 120 14 114.5C14 109 36 85 68.5 85C101 85 125 109 125 113.5C125 118 129.5 131 121.5 123C113.5 115 27 117.5 20 123.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planted1",
    d: "M21 136.5C16 136.5 14 133 14 127.5C14 122 36 98 68.5 98C101 98 125 122 125 126.5C125 131 124 135 121.5 136C119 137 26 136.5 21 136.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BorderCover"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 30C9 24.4772 13.4772 20 19 20H121C126.523 20 131 24.4772 131 30V132C131 137.523 126.523 142 121 142H19C13.4772 142 9 137.523 9 132V30Z M16 32C16 29.2386 18.2386 27 21 27H119C121.761 27 124 29.2386 124 32V130C124 132.761 121.761 135 119 135H21C18.2386 135 16 132.761 16 130V32Z",
    fill: "#82be9a",
    fillRule: "evenodd",
    stroke: "#065c43",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "cellBorder",
    x: 16,
    y: 27,
    width: 108,
    height: 108,
    rx: 5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "spadeRight",
    d: "M109.324 84.5631C112.188 81.0143 107.891 77.8698 105.066 75.5948C101.254 72.5244 97.3347 69.5599 93.5 66.7483L57.1653 114.633C66.2929 120.549 78.4532 112.622 91.9922 102.107C98.4909 97.0594 103.906 91.2755 109.324 84.5631Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "spadeLeft",
    d: "M72.0678 56.603C68.0672 60.5684 43.3272 105.665 57.1653 114.633L93.5 66.7483C88.7692 63.2798 84.1667 60.0443 80.0513 57.1306C75.2612 53.7392 73.6645 55.0204 72.0678 56.603Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "spade",
    d: "M72.0678 56.603C68.0672 60.5684 43.3272 105.665 57.1653 114.633C66.2929 120.549 78.4532 112.622 91.9922 102.107C98.4909 97.0594 103.906 91.2755 109.324 84.5631C112.188 81.0143 107.891 77.8698 105.066 75.5948C96.5505 68.7367 87.5026 62.4061 80.0513 57.1306C75.2612 53.7392 73.6645 55.0204 72.0678 56.603Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "handleBack",
    d: "M107.697 60.9482C104.99 62.0313 95.2415 54.4495 95.7831 51.7417C96.3246 49.034 110.406 46.3262 110.406 46.3262C110.406 46.3262 110.405 59.8651 107.697 60.9482Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connector",
    d: "M104.448 47.9508C104.448 47.9508 91.4506 65.2807 87.1181 71.2378C82.7857 77.195 79.5363 82.6105 80.0779 84.2352C80.6194 85.8599 84.4103 82.6105 90.909 73.9456C97.4077 65.2807 107.697 51.2002 107.697 51.2002L104.448 47.9508Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "handle",
    d: "M137.483 10.0418C136.4 8.95868 129.36 4.62622 122.861 13.2911C117.258 20.7612 101.191 43.5261 96.8662 50.3565C96.1744 51.4491 96.3246 51.7417 96.3246 52.2833C96.3246 52.8249 97.4077 52.8249 97.9493 52.8249C98.4908 52.8249 101.199 53.3664 102.823 54.9911C104.448 56.6157 105.531 58.782 105.826 59.3236C106.122 59.8651 106.614 60.4067 107.156 60.4067C107.697 60.4067 107.908 60.359 108.78 59.3236C114.112 52.9977 133.12 30.0199 137.483 23.0392C142.56 14.9158 138.566 11.1249 137.483 10.0418Z",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "spadeCoverShadow",
    d: "M73 99C58 98.2857 48 103 48 103L97 106C97 106 88 99.7143 73 99Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "spadeCover",
    d: "M24.5 133C19.5 133 23 133 23 127.5C23 122 36 98 68.5 98C101 98 121 121 121 125.5C121 130 120.5 132 118 133C115.5 134 29.5 133 24.5 133Z",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDesignerPic);
export default __webpack_public_path__ + "static/media/gardenDesignerPic.e342279b63fc13d8dfd667496183518e.svg";
export { ForwardRef as ReactComponent };